import type { TRule } from 'fela';

export const title: TRule = () => ({
    fontSize: '1.5rem',
});

export const header: TRule = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});
